import { useQuery } from 'react-query';
import { getCashFlow } from '../../api/statementOfCashFlow';
import { getAllBankDepository } from '../../api/collections';

export const columns = [
  {
    field: 'account_code',
    headerName: 'Account Code',
    width: 150,
    sortable: false,
    hideable: false,
  },
  {
    field: 'account_name',
    headerName: 'Account Description',
    width: 150,
    sortable: false,
    hideable: false,
  },
  {
    field: 'breakdown_type',
    headerName: 'Breakdown Type',
    width: 150,
    sortable: false,
    hideable: false,
  },
];

export const useCashFlowQuery = (tableParams) => {
  return useQuery({
    queryKey: ['statement_of_cashflow', tableParams],
    queryFn: async () => {
      const res = await getCashFlow(tableParams);

      const { code, result } = res.data.response;

      if (code !== '00000') {
        //throw new Error('Unable to load output vat.');
        return Promise.reject(new Error('Unable to load data'));
      }

      return result;
    },
    throwOnError: true,
  });
};

export const useBankDepository = () => {
  return useQuery({
    queryKey: ['bank_depository'],
    queryFn: async () => {
      const res = await getAllBankDepository();

      const { code, result } = res.data.response;

      if (code !== '00000') {
        //throw new Error('Unable to load output vat.');
        return Promise.reject(new Error('Unable to load data'));
      }

      return result;
    },
  });
};
